import { render, staticRenderFns } from "./HowToOpenAPI.vue?vue&type=template&id=3e1ef981&scoped=true&"
import script from "./HowToOpenAPI.vue?vue&type=script&lang=js&"
export * from "./HowToOpenAPI.vue?vue&type=script&lang=js&"
import style0 from "./HowToOpenAPI.vue?vue&type=style&index=0&id=3e1ef981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ef981",
  null
  
)

export default component.exports